import * as React from "react";

export interface GalleryDownloadIconProps {}

export const GalleryDownloadIcon = (props: GalleryDownloadIconProps) => {
    return (
<svg version="1.1" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 56.1 70.4" enableBackground="new 0 0 56.1 70.4;" className="gallery-download-icon">
<g>
	<path fill="#959595" d="M34.2,3.7c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8H4.7C4.3,5.4,3.9,5,3.9,4.6s0.4-0.8,0.8-0.8H34.2z M34,20.1
		V9.1H3.8c-0.5,0-1-0.2-1.5-0.4v25.1c0,2.6,1.7,4.7,3.8,4.7h11.6l0.3,1.7H6.1c-3,0-5.4-2.9-5.4-4.3V5.6c0-4,1.4-5.6,3.1-5.6h30.9
		c0.4,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8H3.8c-0.8,0-1.5,1.9-1.5,3S3,7.5,3.8,7.5h30.9c0.4,0,0.8,0.4,0.8,0.8v11.6"/>
</g>
<circle fill="#8DCECA" cx="32.7" cy="34.9" r="14.6"/>
<circle fill="none" cx="34.7" cy="36.9" r="12"/>
<path fill="#FFFFFF" d="M38.1,36.2c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-4.4,4.4c-0.3,0.3-0.5,0.4-0.9,0.4h-0.1c-0.1,0-0.1,0-0.2,0
	c-0.3,0-0.5-0.2-0.7-0.4l-0.1-0.1L27.3,38c-0.5-0.5-0.5-1.3,0-1.9c0.5-0.5,1.3-0.5,1.9,0l2.1,2.1v-10c0-0.7,0.6-1.3,1.3-1.3
	c0.7,0,1.3,0.6,1.3,1.3v10.1l2.1-2.1C36.8,35.6,37.6,35.6,38.1,36.2z"/>
</svg>
    );
};

